export default __webpack_public_path__ + "static/media/phones-color.af9d7287.svg";